import Vue from 'vue'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

import { moduleRoutes } from './Routes'

const routes = [...moduleRoutes]

const options = {
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }

    return { x: 0, y: 0 }
  },
}

const router = new VueRouter(options)

export default router
